export default __webpack_public_path__ + "assets/0e86435eb488f8d8a198c91c94a5fd29.png";